import { render, staticRenderFns } from "./SetNewPass.vue?vue&type=template&id=1fb4c24a&"
import script from "./SetNewPass.vue?vue&type=script&lang=js&"
export * from "./SetNewPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports